var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconNotOk = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-531 -523)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 16,
  height: 16,
  transform: "translate(531 523)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M-11238.292-14615.636a1,1,0,0,1,0-1.413l1.415-1.414-1.415-1.415a1,1,0,0,1,0-1.416,1,1,0,0,1,1.413,0l1.417,1.415,1.412-1.412a1,1,0,0,1,1.413,0,1,1,0,0,1,0,1.413l-1.411,1.411,1.415,1.414a1.007,1.007,0,0,1,0,1.417,1.007,1.007,0,0,1-1.417,0l-1.414-1.415-1.415,1.415a.99.99,0,0,1-.706.294A.994.994,0,0,1-11238.292-14615.636Z",
  transform: "translate(11774.464 15149.463)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNotOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-not-ok.24ef6b0b.svg";
export { ForwardRef as ReactComponent };